import { render, staticRenderFns } from "./EditGarbageAccessAnalytics.vue?vue&type=template&id=a89ae068"
import script from "./EditGarbageAccessAnalytics.vue?vue&type=script&lang=js"
export * from "./EditGarbageAccessAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports